"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.userToStripeCustomer = function (user) {
  return {
    email: user.emailAddress,
    phone: user.phoneNumber,
    name: user.firstName + " " + user.lastName
  };
};